import type { Point, PointArray } from '../types/contour-definition-array-type';

export function getPolygonAreaAndCentroid(polygon: PointArray): {
  signedArea: number;
  centroid: Point;
} {
  // Validate input
  if (!polygon || polygon.length < 5) {
    return { signedArea: 0, centroid: { x: 0, y: 0 } };
  }

  let centroidWeightedX = 0;
  let centroidWeightedY = 0;
  let signedArea = 0;

  const x0 = polygon[0].x;
  const y0 = polygon[0].y;

  for (let i = 1; i < polygon.length - 1; i++) {
    if (!polygon[i] || !polygon[i + 1]) {
      console.warn(
        `Invalid polygon point at index ${i}:`,
        polygon[i],
        polygon[i + 1],
      );
      return { signedArea: 0, centroid: { x: 0, y: 0 } };
    }

    const xi = polygon[i].x;
    const yi = polygon[i].y;
    const xi1 = polygon[i + 1].x;
    const yi1 = polygon[i + 1].y;

    const subArea = (xi - x0) * (yi1 - y0) - (xi1 - x0) * (yi - y0);
    const centroidX = (x0 + xi + xi1) / 3;
    const centroidY = (y0 + yi + yi1) / 3;

    centroidWeightedX += centroidX * subArea;
    centroidWeightedY += centroidY * subArea;

    signedArea += subArea;
  }

  const centroidX = centroidWeightedX / signedArea;
  const centroidY = centroidWeightedY / signedArea;

  signedArea /= 2;

  return {
    signedArea,
    centroid: { x: centroidX, y: centroidY },
  };
}

// export function getPolygonAreaAndCentroid(polygon: PointArray): { signedArea: number; centroid: Point } {
//     let centroidWeightedX = 0;
//     let centroidWeightedY = 0;
//     let signedArea = 0;

//     const x0 = polygon[0].x;
//     const y0 = polygon[0].y;

//     if (polygon.length < 5) {
//         return { signedArea: 0, centroid: { x: 0, y: 0 } };
//     }

//     for (let i = 1; i < polygon.length - 1; i++) {
//         const xi = polygon[i].x;
//         const yi = polygon[i].y;
//         const xi1 = polygon[(i + 1)].x;
//         const yi1 = polygon[(i + 1)].y;

//         const subArea = (xi - x0) * (yi1 - y0) - (xi1 - x0) * (yi - y0);
//         const centroidX = (x0 + xi + xi1)/3;
//         const centroidY = (y0 + yi + yi1)/3;

//         centroidWeightedX += centroidX * subArea;
//         centroidWeightedY += centroidY * subArea;

//         signedArea += subArea;
//     }

//     const centroidX = centroidWeightedX/signedArea;
//     const centroidY = centroidWeightedY/signedArea;

//     signedArea /=2;

//     return {
//         signedArea,
//         centroid: { x: centroidX, y: centroidY },
//       };
// }
